import { getCardsGroupsData, getFiguregroupsData } from "../getData";
import { createCardsFeaturesV2 } from "./mapboxDataSource";

// editCards action needed
// editFeaturesGroup needed
// editFigures needed
// props projectData needed
export async function reloadCardsGroupsFeatures(props, cardsGroupIds, ignoreIds=[], levelIdsToReload=[]) {
    let newCardsGroupsData = {
        ...props.projectData.cards_groups
    }
    let cardsGroupsData = {};
    if (cardsGroupIds && cardsGroupIds.length) {
        cardsGroupsData = await getCardsGroupsData(cardsGroupIds);
        let figuregroupIds = Object.values(cardsGroupsData).map((cardsGroupsData) => {
            return cardsGroupsData.attributes.figuregroup_id;
        });
        let figuregroupsData = await getFiguregroupsData(props.projectData.id, figuregroupIds);
        updateFiguregroups(props, figuregroupsData);
        props.editCards(cardsGroupsData);
        newCardsGroupsData = {
            ...newCardsGroupsData,
            ...cardsGroupsData
        }
    }
    let levelIds = getLevelIdsToReload(levelIdsToReload, cardsGroupIds, ignoreIds, newCardsGroupsData);
    for (const levelId of levelIds) {
        let featuresGroup = createFeaturesGroup(props, newCardsGroupsData, levelId, ignoreIds);
        props.editFeaturesGroup(featuresGroup, levelId);
    }
    return cardsGroupsData;
}

export function getLevelIdsToReload(levelIdsToReload, cardsGroupIds, ignoreIds, newCardsGroupsData) {
    let levelIds = [...levelIdsToReload];
    for (const cardsGroupId of cardsGroupIds) {
        let cardsGroupData = newCardsGroupsData[cardsGroupId];
        if (!cardsGroupData.attributes) continue;
        let levelId = cardsGroupData.attributes.level_id;
        if (!levelIds.includes(levelId)) {
            levelIds.push(levelId);
        }
    }
    for (const cardsGroupId of ignoreIds) {
        let cardsGroupData = newCardsGroupsData[cardsGroupId];
        if (!cardsGroupData.attributes) continue;
        let levelId = cardsGroupData.attributes.level_id;
        if (!levelIds.includes(levelId)) {
            levelIds.push(levelId);
        }
    }
    return levelIds;
}

function createFeaturesGroup(props, newCardsGroupsData, levelId, ignoreIds) {
    const levelData = props.projectData.levels[levelId];
    const stageId = levelData.attributes.stage_id;
    const cardsGroupsData = getCardsGroupsDataByLevel(newCardsGroupsData, levelId, ignoreIds);
    return  createCardsFeaturesV2(cardsGroupsData, props.projectData, stageId, levelId);
}

function getCardsGroupsDataByLevel(cardsGroupsData, levelId, ignoreIds) {
    levelId = parseInt(levelId);
    let cardsGroupsDataByLevel = {};
    for (const cardsGroupData of Object.values(cardsGroupsData)) {
        if (ignoreIds.includes(cardsGroupData.id)) continue;
        if (cardsGroupData.attributes.level_id === levelId) {
            cardsGroupsDataByLevel[cardsGroupData.id] = cardsGroupData;
        }
    }
    return cardsGroupsDataByLevel;
}

export function updateFiguregroups(props, figuregroupsData) {
    let figuresData = props.projectData.figures;
    let figuregroupsMap = props.projectData.figuregroups_map;
    for (const figuregroupData of Object.values(figuregroupsData)) {
        let figureIds = Object.values(figuregroupData.figures).map((figureData) => {
            return figureData.id;
        });
        figuregroupsMap[figuregroupData.id] = figureIds;
        for (const figureId of figureIds) {
            if (figuresData[figureId]) {
                figuresData[figureId].figuregroups[figuregroupData.id] = figuregroupData;
            } else {
                figuresData[figureId] = figuregroupData.figures[figureId];
                figuresData[figureId].figuregroups = {};
                figuresData[figureId].figuregroups[figuregroupData.id] = figuregroupData;
            }
        }
    }
    props.editFigures(figuresData, figuregroupsMap);
}